import React from "react";
import { Link } from "gatsby";
import Layout from "../components/shared/Layout";
import "../assets/styles/pages/404.scss";
import HomeIcon from "../assets/svg/menu/home.inline.svg";

const NotFound = () => (
  <Layout>
    <div className={"wrapper"}>
      <div className="block-wrap">
        <div className={"text-block"}>
          <p className="code">404</p>
          <p className="message">อุ๊ย! สงสัยลิงก์นี้จะใช้การไม่ได้ หรือ URL ไม่ถูกต้องนะคะ</p>
          <p>
            <Link to={"/"} className={"button"}>
              <HomeIcon/>
              <span>Gclub24hr</span>
            </Link>
          </p>
        </div>
      </div>
    </div>
  </Layout>
);

export default NotFound;
